export default function scrollToInvalidInput(form: HTMLFormElement) {
  const invalidElem = form.querySelector(":invalid");

  if (invalidElem) {
    // invalidElem.scrollIntoView({
    //   behavior: "smooth",
    //   block: "start",
    // });
    window.scrollTo({
      top: (invalidElem as HTMLElement).offsetTop - 200,
      behavior: "smooth",
    });
  }
}
